/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Approvals_Link_UnavailableInputs */



/**
* | output |
* | --- |
* | "This approval is no longer waiting for you. It may already be decided, or it expired." |
*
* @param {Agent_Approvals_Link_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_approvals_link_unavailable = /** @type {((inputs?: Agent_Approvals_Link_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Approvals_Link_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Freigabe wartet nicht mehr auf Sie. Sie ist bereits entschieden oder abgelaufen.")
	return /** @type {LocalizedString} */ ("This approval is no longer waiting for you. It may already be decided, or it expired.")
});